export const ErrorCode = {
  NoDelPermission: 'No_Del_Permission',
}